/**
 * Ordnet Kartenzahlungen automatisch einer Ausgaben-Kategorie zu. Erste Wahl ist
 * der MCC (Merchant Category Code) der Zahlung; fehlt er oder ist unbekannt, wird
 * anhand des Haendlernamens geschaetzt. Reine Logik ohne Redux/React, damit der
 * Import-Parser sie direkt nutzen kann. Der Nutzer korrigiert Vorschlaege spaeter
 * im Import-Dialog.
 */

// MCC (Merchant Category Code) -> Standard-Ausgaben-Kategorie.
const MCC_KATEGORIE = {
  // Lebensmittel, Baeckereien, Getraenke
  5411: 'Lebensmittel', 5422: 'Lebensmittel', 5441: 'Lebensmittel',
  5451: 'Lebensmittel', 5462: 'Lebensmittel', 5499: 'Lebensmittel', 5921: 'Lebensmittel',
  // Mobilitaet: Tanken, Parken, Verkehr, Maut
  5541: 'Mobilität', 5542: 'Mobilität', 5983: 'Mobilität', 4111: 'Mobilität',
  4112: 'Mobilität', 4121: 'Mobilität', 4131: 'Mobilität', 4784: 'Mobilität',
  7523: 'Mobilität', 7538: 'Mobilität', 7549: 'Mobilität',
  // Restaurant und Gastronomie
  5811: 'Restaurant', 5812: 'Restaurant', 5813: 'Restaurant', 5814: 'Restaurant',
  // Freizeit, Reise, Unterhaltung
  7011: 'Freizeit', 7032: 'Freizeit', 7033: 'Freizeit', 7832: 'Freizeit',
  7922: 'Freizeit', 7941: 'Freizeit', 7991: 'Freizeit', 7996: 'Freizeit',
  7997: 'Freizeit', 7998: 'Freizeit', 7999: 'Freizeit',
  // Shopping und Handel
  5309: 'Shopping', 5310: 'Shopping', 5311: 'Shopping', 5611: 'Shopping',
  5621: 'Shopping', 5631: 'Shopping', 5641: 'Shopping', 5651: 'Shopping',
  5655: 'Shopping', 5661: 'Shopping', 5691: 'Shopping', 5699: 'Shopping',
  5732: 'Shopping', 5733: 'Shopping', 5734: 'Shopping', 5941: 'Shopping',
  5942: 'Shopping', 5943: 'Shopping', 5944: 'Shopping', 5945: 'Shopping',
  5977: 'Shopping', 5992: 'Shopping', 5999: 'Shopping',
  // Abos, Digitales, Telekom
  4814: 'Abos', 4899: 'Abos', 5815: 'Abos', 5816: 'Abos', 5817: 'Abos', 5818: 'Abos',
  // Gesundheit
  5122: 'Gesundheit', 5912: 'Gesundheit', 8011: 'Gesundheit', 8021: 'Gesundheit',
  8031: 'Gesundheit', 8042: 'Gesundheit', 8043: 'Gesundheit', 8049: 'Gesundheit',
  8062: 'Gesundheit', 8071: 'Gesundheit', 8099: 'Gesundheit',
  // Wohnen, Versorger
  4900: 'Wohnen',
};

// Namens-Schluesselwoerter als Reserve, wenn der MCC fehlt oder unbekannt ist.
// Reihenfolge = Priorisierung (spezifische Gruppen zuerst).
const NAME_MUSTER = [
  { kategorie: 'Lebensmittel', woerter: ['edeka', 'rewe', 'lidl', 'aldi', 'penny', 'netto', 'kaufland', 'marktkauf', 'mpreis', 'backwaren', 'baeckerei', 'bäckerei', 'baecker', 'bäcker', 'metzger', 'supermarkt'] },
  { kategorie: 'Restaurant', woerter: ['mcdonald', 'burger king', 'kfc', 'subway', 'pizza', 'doner', 'döner', 'kebap', 'kebab', 'restaurant', 'gastro', 'cafe', 'caffe', 'coffee', 'starbucks', 'imbiss', 'grill', 'osteria'] },
  { kategorie: 'Mobilität', woerter: ['tankstelle', 'tankst', 'aral', 'esso', 'shell', 'jet-', 'avia', 'agip', 'service-station', 'service station', 'parkhaus', 'parkraum', 'parch', 'parking', 'flixbus', 'uber'] },
  { kategorie: 'Abos', woerter: ['apple.com', 'netflix', 'spotify', 'amazon prime', 'disney', 'youtube', 'adobe', 'openai'] },
  { kategorie: 'Gesundheit', woerter: ['apotheke', 'pharmacy', 'zahnarzt', 'optik', 'fielmann'] },
  { kategorie: 'Shopping', woerter: ['adidas', 'nike', 'puma', 'hugo boss', 'under armour', 'zalando', 'thalia', 'mcpaper', 'media markt', 'saturn', 'ikea', 'decathlon', 'rossmann', 'blume'] },
];

/** Schaetzt die Ausgaben-Kategorie einer Kartenzahlung (MCC zuerst, sonst Name). */
export function kategorieFuerAusgabe(mcc, name) {
  const perMcc = MCC_KATEGORIE[Number(mcc)];
  if (perMcc) return perMcc;
  const text = (name || '').toLowerCase();
  const treffer = NAME_MUSTER.find((m) => m.woerter.some((w) => text.includes(w)));
  return treffer ? treffer.kategorie : 'Sonstiges';
}
